<template>
  <!-- 登录页面最外层容器，设置全屏背景 -->
  <div class="login-page">
    <!-- 登录卡片容器，白色居中卡片 -->
    <div class="login-card">
      <!-- 系统名称标题 -->
      <h2 class="system-title">电商运营管理系统</h2>

      <!--
        登录表单
        @submit.native.prevent：监听表单原生提交事件，阻止页面默认刷新
        提交后执行 login 登录方法
      -->
      <el-form @submit.native.prevent="login" class="login-form">
        <!-- 用户名输入框表单项 -->
        <el-form-item>
          <el-input
            v-model="form.username"
            placeholder="请输入用户名(admin)"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <!-- 密码输入框表单项 -->
        <el-form-item>
          <el-input
            v-model="form.password"
            placeholder="请输入密码(123456)"
            type="password"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>

        <!-- 登录按钮 -->
        <el-form-item>
          <el-button
            type="primary"
            native-type="submit"
            class="login-btn"
          >
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  // 组件数据定义
  data() {
    return {
      // 登录表单数据对象
      form: {
        username: '',
        password: ''
      }
    }
  },

  // 页面方法集合
  methods: {
    // 异步登录方法
    async login() {
      // 前端校验：账号密码不能为空
      if (!this.form.username || !this.form.password) {
        this.$message.warning('请输入账号和密码')
        return
      }

      // 向后端发送登录请求
      const { data } = await this.$axios.post('/api/login', this.form)

      // 登录成功
      if (data.code === 200) {
        // 将 token 存入会话缓存，保持登录状态
        sessionStorage.setItem('token', data.token)
        // 跳转到首页
        this.$router.push('/home')
        // 提示登录成功
        this.$message.success('登录成功')
      } else {
        // 登录失败提示
        this.$message.error('账号或密码错误')
      }
    }
  }
}
</script>

<style scoped>
/* 登录页面整体样式：全屏背景 + 居中布局 */
.login-page {
  height: 100vh;
  background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)),
              url('https://tse.baidu.com/it/u=2581956080,2591448760&fm=253&fmt=auto&app=138&f=JPEG?w=1000&h=667') no-repeat center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 登录卡片样式：白色卡片、圆角、阴影 */
.login-card {
  width: 420px;
  padding: 40px 30px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}

/* 系统标题样式 */
.system-title {
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  color: #333;
  font-weight: bold;
}

/* 表单整体间距 */
.login-form {
  margin-top: 10px;
}

/* 登录按钮样式：宽屏、高大、美观 */
.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
}
</style>